export default "__VITE_ASSET__BEbswOJ8__"